import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';

export default function TableList() {
    const { useLang } = useGlobal();
    const { t } = useLang('TrailSeries.tabSwriper.tableList');

    const columns = [
        {
            title: t('column1_title'),
        },
        {
            title: t('column2_title'),
        },
        {
            title: t('column3_title'),
        },
        {
            title: t('column4_title'),
        },
    ];

    const data = [...new Array(21)].map((item, index) => {
        return {
            appliance: t(`row${index + 1}_col1_item`),
            trail200: t(`row${index + 1}_col2_item`),
            trail300: t(`row${index + 1}_col3_item`),
            units: t(`row${index + 1}_col4_item`),
        };
    });

    return (
        <div className={`page-tableList ${styles.TableList}`}>
            <div className="table-list-container">
                <table>
                    <thead>
                        <tr>
                            {columns.map((column: any) => (
                                <th key={column.title}>{column.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.appliance}</td>
                                <td>{item.trail200}</td>
                                <td>{item.trail300}</td>
                                <td>{item.units}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
